<script setup lang="ts">
import {
  useSessionStore,
} from "~/stores/session";
import {
  useLocaleStore,
} from "~/stores/locale";

const sessionStore = useSessionStore();
const localeStore = useLocaleStore();

onMounted(() => {
  sessionStore.initialize();
  localeStore.initialize();
});
</script>

<template>
  <el-config-provider :locale="localeStore.elLocale">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <abstract-dialog />
  </el-config-provider>
</template>
